/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2024, Zumper
 */

import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import { logger } from '@zcode/utils'
import React from 'react'
import type { ErrorBoundaryProps } from 'react-error-boundary'

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for HomepageExploreRentals lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for HomepageExploreRentals lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () => await import('./HomepageExploreRentals')

const handleReload = async () => await HomepageExploreRentalsLazyLoadable.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback message="Error loading the nearby listings" onClickReload={handleReload} />
  ),

  loadingFallback: () => <LoadingFallback height="1100px" name="nearby listings" />,
  onRenderError,
  onLoadingError,
}

export const HomepageExploreRentalsLazyLoadable = createLazyLoadableSection(loadFn, options)
